import React from 'react';
import './CategoryTable.scoped.scss';
import {cellNames, tableElements, tableElementsTitle} from './const';
import {Button} from "../../common";
import PrimaryButton, {PrimaryButtonColor} from "../../common/buttons/decorators/PrimaryButton/PrimaryButton";

const CategoryTable = () => {
  const downloadFile = () => {
    const tag = document.createElement('a');
    tag.href = 'https://drive.google.com/u/0/uc?id=1YtnsYYvVDmA5vOcOkHsiLx6E9xnNPejt&export=download';

    tag.download = 'CategoryTable';
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  return (
    <>
      <table className="category-table">
        <tr>
          <td className="category-table__title"></td>
          {tableElementsTitle.map((title) => (
            <td key={title} className="category-table__title">{title}</td>
          ))}
        </tr>
        {Object.entries(tableElements).map(([rowName, rowElements]) => (
          <tr key={rowName}>
            <td className="category-table__title">{rowName}</td>
            {rowElements.map(cell => (
              <td key={cell.column} className={`category-table__cell__${cell.cell}`}>
                <p className='category-table__text__bold'>{`${rowName}/${cell.column}`}</p>
                <p className='category-table__text'>{cellNames[cell.cell]}</p></td>
            ))}

          </tr>
        ))}
      </table>
      <PrimaryButton color={PrimaryButtonColor.GREEN} className={'category-table__download-button'}>
        <Button onClick={downloadFile}>Скачать</Button>
      </PrimaryButton>
    </>
  );
};

export default CategoryTable;

